/** MarketingAttributionCockpit — Cockpit frame for /marketing-attribution. */
import { useMemo } from "react";
import { CockpitPage, CockpitMasthead, HeroMetric, HeroDivider, CockpitKpiStrip } from "@/components/cockpit/CockpitShell";
import { BackToLeadPerformance } from "@/components/BackToLeadPerformance";
import { useAppData } from "@/data/AppDataContext";
import MarketingAttribution from "./MarketingAttribution";

export default function MarketingAttributionCockpit() {
  const { jobs, salesOpportunities } = useAppData();
  const k = useMemo(() => {
    const revenue = jobs.reduce((s, j) => s + (j.financials?.contractValue ?? 0), 0);
    const sources = new Set(salesOpportunities.map(o => o.leadSource).filter(Boolean));
    const won = salesOpportunities.filter(o => o.stage === "Closed Won").length;
    return { revenue, sources: sources.size, won, leads: salesOpportunities.length };
  }, [jobs, salesOpportunities]);
  return (
    <CockpitPage>
      <CockpitMasthead
        back={<BackToLeadPerformance />}
        eyebrow="Reporting · Attribution"
        title="Marketing Attribution"
        right={
          <>
            <HeroMetric label="Attributed Revenue" value={`$${(k.revenue / 1000).toFixed(0)}K`} hero />
            <HeroDivider />
            <HeroMetric label="Active Sources" value={k.sources} />
            <HeroDivider />
            <HeroMetric label="Wins" value={k.won} tone="good" />
          </>
        }
      />
      <CockpitKpiStrip
        items={[
          { label: "Total Leads", value: k.leads },
          { label: "Wins", value: k.won, tone: "good" },
          { label: "Sources Tracked", value: k.sources },
        ]}
      />
      <div className="cockpit-surface"><MarketingAttribution /></div>
    </CockpitPage>
  );
}
